import { takeLatest, call, put, select } from "redux-saga/effects"
import {
  getPlansWatcher,
  getPlansSuccess,
  getPlansFailed,
  updatePhotoSuccess,
} from "./actions"
import { GET_PLANS_WATCHER, UPDATE_PHOTO_WATCHER } from "./constants"

// GET PLANS
export function* getPlansSaga(action) {
  try {
    const { data } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `ambassadors/${action.payload.id_ambassador}`,
      params: action.payload,
    })
    const result = {
      plans: data.action_plans,
      ambassador: data.ambassador[0],
      divisions: data.divisions,
      filter: data.filter,
      count_action_plans: data.count_action_plans,
      leader_team: data.leader_team,
      current_user_can_action: data.current_user_can_action,
    }
    yield put(getPlansSuccess(result))
    yield put(updatePhotoSuccess())
  } catch (error) {
    returnMessage(error)
    getPlansFailed({})
  }
}

export function* updatePhotoSaga(action) {
  try {
    const response = yield call(fetchGlobalApi, {
      method: "post",
      endpoint: `ambassadors/${action.payload.get("id")}/updatePhoto`,
      data: action.payload,
    })

    yield put(getPlansWatcher({ id_ambassador: action.payload.get("id") }))
  } catch (error) {
    yield put(updatePhotoSuccess())
  }
}

// Individual exports for testing
export default function* profileAmbassadorSaga() {
  yield takeLatest(GET_PLANS_WATCHER, getPlansSaga)
  yield takeLatest(UPDATE_PHOTO_WATCHER, updatePhotoSaga)
}
